import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import defaultStyles from './TradePricedFooter.module.scss';
import BookSelectedTrades from './ProcessSelectedTrades';

const calculateNumberOfTradesSelected = trades => (
    trades.filter(trade => trade.selected && !trade.booked).length
);

const TradePricedFooter = props => (
    <div className={ props.styles.tradePricedTodayFooter }>
        <div className={ props.styles.tradesSelected }>
            {calculateNumberOfTradesSelected(props.trades)} Trades Included
        </div>
        <div className={ props.styles.separator }>&nbsp;</div>
        <div className={ props.styles.bookedTrades }>
            <BookSelectedTrades
                process="Book"
                processSelectedTrades={ props.bookSelectedTrades }
            />
        </div>
        <div className={ props.styles.separator }>&nbsp;</div>
        <div className={ props.styles.deleteSelectedTrades }>
            <BookSelectedTrades
                process="Delete"
                processSelectedTrades={ props.deleteSelectedTrades }
            />
        </div>
    </div>

);

TradePricedFooter.propTypes = {
    bookSelectedTrades: PropTypes.func,
    deleteSelectedTrades: PropTypes.func,
    styles: PropTypes.objectOf(PropTypes.string),
    trades: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            checked: PropTypes.bool,
            booked: PropTypes.bool
        })
    )
};

TradePricedFooter.defaultProps = {
    bookSelectedTrades: noop,
    deleteSelectedTrades: noop,
    styles: defaultStyles,
    trades: []
};

export default TradePricedFooter;
